/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Anonymize_WarningInputs */



/**
* | output |
* | --- |
* | "This cannot be undone, and it is not sent to VEKN." |
*
* @param {Member_Anonymize_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_anonymize_warning = /** @type {((inputs?: Member_Anonymize_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Anonymize_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette action est irréversible et n'est pas transmise à la VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta acción no se puede deshacer y no se envía a la VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Esta ação não pode ser desfeita e não é enviada à VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'operazione è irreversibile e non viene inviata alla VEKN.")
	return /** @type {LocalizedString} */ ("This cannot be undone, and it is not sent to VEKN.")
});